import React from "react";
import { groupMetrics } from "./fiData";
import { FormStrip } from "./TeamPanels";
import MirroredBars from "./MirroredBars";
import "./fi-extra.css";

/**
 * Comparison of two entities over the same filters, grouped by metric family.
 * Nothing is league-adjusted and no percentiles are shown: a suitable
 * position/competition population has not been established.
 */
export default function CompareView({ a, b, kind, per90 }) {
  const player = kind === "player";
  const pick = (metric) => (metric ? (player && per90 ? metric.per90 : metric.value) : null);
  const groups = groupMetrics(kind, a.metrics || {});
  const nameA = a.profile?.name;
  const nameB = b.profile?.name;

  return (
    <div>
      <div className="fx-key">
        <span className="a">● {nameA}</span>
        <span className="b">{nameB} ●</span>
      </div>
      <p className="fi-note" style={{ marginTop: 0 }}>
        Raw matched filters, {player ? (per90 ? "per-90 exposure" : "season totals") : "match means"}. Samples: {a.sample_size ?? 0} vs {b.sample_size ?? 0}. Not league-adjusted. No percentiles: a suitable position/competition population has not been established.
      </p>

      {!player && (
        <div className="fx-pair" style={{ margin: "0 0 16px" }}>
          <div><div className="fx-embedded-ink" style={{ fontSize: 12, marginBottom: 6 }}>{nameA}</div><FormStrip matches={a.matches || []} /></div>
          <div><div className="fx-embedded-ink" style={{ fontSize: 12, marginBottom: 6 }}>{nameB}</div><FormStrip matches={b.matches || []} /></div>
        </div>
      )}

      {groups.map((group) => {
        const rows = group.items
          .map(({ key, label, metric }) => ({
            key,
            label,
            a: pick(metric),
            b: pick(b.metrics?.[key]),
            na: metric?.sample ?? 0,
            nb: b.metrics?.[key]?.sample ?? 0,
          }))
          .filter((row) => typeof row.a === "number" || typeof row.b === "number");
        if (!rows.length) return null;
        return (
          <section key={group.id} style={{ marginBottom: 18 }}>
            <h4 style={{ margin: "0 0 4px", fontSize: 13 }}>{group.title}</h4>
            <MirroredBars rows={rows} nameA={nameA} nameB={nameB} mean={!player} />
          </section>
        );
      })}
    </div>
  );
}
